const phoneReg = /^1[3456789]\d{9}$/
// 密码只能由数字、字母、符号组成，并且不少于6位
const passWordReg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/
// const passWordReg = /^(?![A-z0-9]+$)(?=.[^%&',:=?$\x22])(?=.*[a-z])(?=.*[0-9]).{6,}$/
const chineseReg = /.*[\u4e00-\u9fa5]+.*$/
const FormValidate = (function () {
  function FormValidate() { }
  FormValidate.Form = function () {
    return {
      validatePhone(rule, value, callback) {
        if (!value) {
          return callback(new Error('号码不能为空!'))
        }
        if (!phoneReg.test(value)) {
          callback(new Error('号码格式有误'))
        } else {
          callback()
        }
      },
      validatePwd(rule, value, callback) {
        if (!value) {
          return callback(new Error('密码不能为空!'))
        }
        if (chineseReg.test(value)) {
          return callback(new Error('密码只能由数字、字母、符号组成，并且不少于6位'))
        }
        if (value.length < 6) {
          callback(new Error('密码只能由数字、字母、符号组成，并且不少于6位'))
        } else {
          callback()
        }
      },
    }
  }
  return FormValidate
}())

exports.FormValidate = FormValidate